var MyLatLng = new google.maps.LatLng(35.6811673, 139.7670516);
var Options = {
  zoom: 15,
  center: MyLatLng,
  mapTypeId: 'roadmap'
};
var mapElements = document.getElementsByClassName('js-gmap');
for(var i = 0; i < mapElements.length; i++) {
  var map = new google.maps.Map(mapElements[i], Options);
}
